<template>
  <div class="login-mode-box">
    <div class="item" @click="MenuChange(0)">
      <img :src="wechat" alt />
    </div>
    <div class="item" @click="MenuChange(1)">
      <img :src="talk" alt />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.login-mode-box {
  width: 80%;
  margin: 90px auto 0 auto;
  display: flex;
  .item {
    flex: 1;
    cursor: pointer;
    text-align: center;
  }
}
</style>


<script>
export default {
  components: {},
  data() {
    return {
      wechat: require("../../assets/wechat.png"),
      talk: require("../../assets/talk.png")
    };
  },
  mounted() {},
  methods: {
    MenuChange(e){
      this.$emit('change',e)
    }
  }
};
</script>
